import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';

export const TriangleOpenIcon = () => (
    <div className="expansion-panel-icon">
        <FontAwesomeIcon icon={faCaretDown} />
    </div>
)
export default TriangleOpenIcon;




// WEBPACK FOOTER //
// ./src/components/icons/TriangleOpenIcon.js